import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { KeepGoingPromoModalContent } from './KeepGoingPromoModalContent';

export const KeepGoingPromoModal = () => {
  return (
    <AppModal
      modalName={Modals.KEEP_GOING_PROMO}
      maxWidth={false}
      scroll="paper"
      transparentBackground
      disableBackdropClick>
      <KeepGoingPromoModalContent />
    </AppModal>
  );
};
